import {Suspense} from "react";
import {ThemeProvider} from "@mui/material";

import theme from "@/theme/default.ts"
import AppRoutes from "@/AppRoutes.tsx";
import {AppProvider} from "@/context/app";

import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ModuleFallBack from "@/components/ModuleFallBack";
import InitialDataLoader from "@/components/InitialDataLoader";

function App() {
    return (
        <ThemeProvider theme={theme}>
            <Suspense fallback={<ModuleFallBack/>}>
                <AppProvider>
                    <InitialDataLoader/>
                    <AppRoutes/>
                    <ToastContainer theme={"colored"}/>
                </AppProvider>
            </Suspense>
        </ThemeProvider>

    )
}

export default App
